import { inject } from '@angular/core'
import { CanActivateFn, Router } from '@angular/router'
import { readPermissionRouteData } from 'shared/utils/permission.util'
import { AuthService } from '@shared-services/auth.service'

export const permissionGuard: CanActivateFn = (route) => {
  const auth = inject(AuthService)
  const router = inject(Router)
  const path = route.routeConfig?.path
  const permissionData = readPermissionRouteData(route.data)

  if (!path) return true

  if (permissionData.resourceCode) {
    return auth.hasCapability({
      resourceCode: permissionData.resourceCode,
      action: permissionData.requiredAction ?? 'view',
    })
      ? true
      : router.createUrlTree(['/'])
  }

  if (permissionData.anyResourceCodes?.length) {
    return permissionData.anyResourceCodes.some((resourceCode) => auth.hasCapability({
      resourceCode,
      action: permissionData.requiredAction ?? 'view',
    }))
      ? true
      : router.createUrlTree(['/'])
  }

  return router.createUrlTree(['/'])
}
